// extracted by mini-css-extract-plugin
module.exports = {"kind-company":"KindCompany_kind-company__1FrOd","tag-badge":"KindCompany_tag-badge__2jmz2","company":"KindCompany_company__1ei7c"};